import React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';

export default function Progress() {
  return (
    <Wrapper>
      <CircularProgress thickness={4.5} size={100} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
`;
